export default __webpack_public_path__ + "static/media/logo.0cf3ea25.png";